export default __webpack_public_path__ + "static/media/4d.7f650950.svg";